import React from 'react';
import { Avatar, Flex, Text, VStack } from '@chakra-ui/react';
import ModalShell from '../../../../components/ui/ModalShell';
import { ff } from '../../../../theme';
import { SheetButton, SheetFooter, SheetHeader } from './sheetParts';

interface ConfirmRejectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmReject: () => void;
  /** Campaign name and chosen reason, for the summary card. */
  title?: string;
  reason?: string;
  brandName?: string;
  imageSrc?: string;
}

/** Final decline confirm (pay / deliverable reason with no counter left). */
const ConfirmRejectModal: React.FC<ConfirmRejectModalProps> = ({ isOpen, onClose, onConfirmReject, title, reason, brandName, imageSrc }) => (
  <ModalShell
    isOpen={isOpen}
    onClose={onClose}
    hideClose
    footer={
      <SheetFooter>
        <SheetButton tone="outline" onClick={onClose}>Keep invite</SheetButton>
        <SheetButton tone="red" onClick={onConfirmReject}>Decline invite</SheetButton>
      </SheetFooter>
    }
  >
    <SheetHeader
      title="Decline invite?"
      onClose={onClose}
      onBack={onClose}
      step={{ index: 2, total: 2, name: 'Confirm' }}
      sub="Once declined, this offer will no longer be accessible."
    />
    {title && (
      <Flex p="14px" borderRadius="16px" bg={ff.grey} align="center" gap="12px">
        <Avatar
          src={imageSrc}
          name={brandName}
          boxSize="44px"
          borderRadius="12px"
          bg={ff.card}
          color={ff.ink}
          flex="none"
          sx={{ '& > [role=img]': { fontSize: '14px', fontWeight: 600 }, img: { borderRadius: '12px' } }}
        />
        <VStack flex={1} minW={0} align="stretch" spacing="2px">
          <Text fontSize="15px" fontWeight={600} lineHeight="normal" noOfLines={1}>{title}</Text>
          {reason && <Text fontSize="13px" color="#55555A" lineHeight="normal">Reason: {reason}</Text>}
        </VStack>
      </Flex>
    )}
  </ModalShell>
);

export default ConfirmRejectModal;
